import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b2a7b09"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = {
  class: "dialog-foter"
};
import { getUsers, getUsersForm, updatePass, getRoleOptions, getDeptOptions, delUsers, addUsers, updateUsers } from "@/api/system1/role";
import { getPublicKey } from "@/api/system1/user";
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick, computed } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { weChatrequest } from '@/utils/request';
import JSEncrypt from 'jsencrypt';
export default {
  __name: 'index',
  setup(__props) {
    const form = ref(null);
    const form1 = ref(null);
    const store = useStore();
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '用户管理';
    });
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "正常"
    }, {
      dictValue: 0,
      dictLabel: "停用"
    }]);
    const statusOptions1 = ref([]);
    const statusOptions2 = ref([]);
    const statusOptions3 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 用户表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keywords: ''
      },
      form1: {
        password: '',
        id: ''
      },
      // 表单参数
      form: {
        mobile: '',
        gender: 0,
        username: '',
        nickname: '',
        roleIds: [],
        areaId: '',
        email: '',
        status: 1,
        actOp: 0,
        // alertSmsEnabled:0,
        userType: null,
        tenantId: null,
        actAuditor: ''
      },
      rules1: {
        password: [{
          required: true,
          message: "新密码不能为空",
          trigger: "blur"
        }, {
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          message: "密码必须包含字母、数字和英文特殊字符，长度为最少8位",
          trigger: "blur"
        }]
      },
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: "用户名不能为空",
          trigger: "blur"
        }],
        tenantId: [{
          required: true,
          message: "所属租户不能为空",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "用户昵称不能为空",
          trigger: "blur"
        }],
        roleIds: [{
          required: true,
          message: "用户角色不能为空",
          trigger: "blur"
        }],
        areaId: [{
          required: true,
          message: "部门权限不能为空",
          trigger: "blur"
        }],
        actAuditor: [{
          required: true,
          message: "审核人不能为空",
          trigger: "blur"
        }],
        email: [{
          pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
          message: "请输入正确的邮箱地址",
          trigger: "blur"
        }],
        mobile: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      publicKey: '',
      searchFormData: [{
        prop: "keywords",
        label: "关键字",
        placeholder: "用户名/昵称/手机号",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "status",
        label: "状态",
        placeholder: "请选择状态",
        type: "list",
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['sys:user:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['sys:user:delete'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }],
      tableHeader: [{
        prop: "username",
        label: "用户名"
      }, {
        prop: "nickname",
        label: "用户昵称"
      }, {
        prop: "genderLabel",
        label: "性别"
      }, {
        prop: "mobile",
        label: "手机号码"
      }, {
        prop: "status",
        label: "状态",
        statusList: [{
          value: 1,
          label: "正常"
        }, {
          value: 0,
          label: "停用"
        }]
      }, {
        prop: "createTime",
        label: "创建时间"
      }, {
        prop: "operation",
        label: "操作",
        width: "200px",
        fixed: "right",
        operation: [{
          name: '重置密码',
          clickFun: row => handleDataScope(row),
          hasPermi: ['sys:user:password:reset']
        }, {
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['sys:user:edit']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['sys:user:delete']
        }]
      }],
      form1Data: [{
        prop: "password",
        label: "新密码",
        placeholder: "请输入新密码",
        type: "text",
        isSelect: false,
        span: 24
      }],
      formScopeData: [{
        prop: "userType",
        label: "用户类型",
        placeholder: "请选择用户类型",
        span: 24,
        type: "list",
        multiple: false,
        isSelect: false,
        options: [{
          dictValue: 1,
          dictLabel: "普通用户"
        }, {
          dictValue: 2,
          dictLabel: "租户管理员"
        }, {
          dictValue: 3,
          dictLabel: "平台用户"
        }],
        // props: { label: "label", value: "value" },
        change: val => {
          if (val == 3) {
            state.form.tenantId = null;
          }
        },
        span: 24,
        hideHandle() {
          return userType != 3; //普通用户和租户管理员创用户隐藏用户类型,只有超管显示
        }
      }, {
        prop: "username",
        label: "用户名",
        placeholder: "请输入用户名称",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "nickname",
        label: "用户昵称",
        placeholder: "请输入用户昵称",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "gender",
        label: "性别",
        placeholder: "请选择性别",
        type: "list",
        options: [{
          value: 0,
          label: "保密"
        }, {
          value: 1,
          label: "男"
        }, {
          value: 2,
          label: "女"
        }],
        props: {
          label: "label",
          value: "value"
        },
        isSelect: false,
        span: 24
      }, {
        prop: "tenantId",
        label: "所属租户",
        placeholder: "请选择所属租户",
        span: 24,
        type: "list",
        multiple: false,
        isSelect: false,
        options: tenantInfos,
        props: {
          label: "tenantName",
          value: "tenantId"
        },
        change: () => {},
        span: 24,
        hideHandle() {
          return userType != 3 || state.form.userType == 3; //普通用户和租户管理员创用户隐藏所属租户,只有超管显示
        }
      }, {
        prop: "roleIds",
        label: "角色",
        placeholder: "请选择角色",
        type: "list",
        multiple: true,
        isSelect: false,
        options: statusOptions1,
        props: {
          label: "label",
          value: "value"
        },
        change: () => {},
        span: 24
      }, {
        prop: "mobile",
        label: "手机号",
        placeholder: "请输入手机号",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "email",
        label: "邮箱",
        placeholder: "请输入邮箱",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "areaId",
        label: "所属地区",
        placeholder: "请选择所属地区",
        type: "cascaderCheck",
        multiple: false,
        isSelect: false,
        options: statusOptions2,
        width: '100%',
        props: {
          label: "name",
          value: "id",
          multiple: false,
          checkStrictly: true
        },
        change: val => {
          console.log(val[val.length - 1], 'val=');
          state.form.areaId = val[val.length - 1];
        },
        span: 24
      }, {
        prop: "actOp",
        label: "是否有执行器操作权限",
        placeholder: "请选择",
        type: "radio",
        isSelect: false,
        options: statusOptions3,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: val => {},
        span: 24
      }, {
        prop: "actAuditor",
        label: "审核人",
        type: "bigData_list_multi",
        placeholder: "请选择审核人",
        multiple: false,
        span: 24,
        method: "get",
        dataType: 'data',
        optionsUrl: "/ty-iot-manage/api/v1/users/listAll",
        props: {
          label: 'nickname',
          value: 'id'
        },
        hideHandle() {
          return state.form.actOp == 1;
        },
        queryParams: {
          pageSize: 1000,
          pageNum: 1
        }
      },
      // {
      //   prop: "alertSmsEnabled",
      //   label: "是否接收告警信息",
      //   placeholder: "请选择",
      //   type: "radio",
      //   isSelect: false,
      //   options: statusOptions3,
      //   props: { label: "dictLabel", value: "dictValue" },
      //   change: (val) => {

      //   },
      //   span: 24
      // },
      {
        prop: "status",
        label: "状态",
        placeholder: "请选择状态",
        type: "radio",
        isSelect: false,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }]
    });
    onMounted(() => {
      // 获取角色下拉
      getRoleOptions().then(response => {
        if (response.code == 0) {
          console.log(response, 'statusOptions1.value===');
          statusOptions1.value = response.data;
        }
      }).catch(() => {});
      // 获取地区下拉
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        statusOptions2.value = [res.data];
      });
    });
    /** 查询用户列表 */
    const getList = function () {
      state.loading = true;
      getUsers(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.list,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        mobile: '',
        gender: 0,
        username: '',
        nickname: '',
        roleIds: [],
        areaId: '',
        email: '',
        status: 1,
        userType: null,
        tenantId: null,
        actOp: 0,
        // alertSmsEnabled:0,
        actAuditor: ''
      };
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        mobile: '',
        gender: 0,
        username: '',
        nickname: '',
        roleIds: [],
        areaId: '',
        email: '',
        status: 1,
        actOp: 0,
        // alertSmsEnabled:0,
        userType: null,
        tenantId: null,
        actAuditor: ''
      };
      // 如果是租户管理员，设置默认租户ID
      if (userType == 2) {
        const defaultTenantId = window.localStorage.getItem("tenantId");
        if (defaultTenantId) {
          state.form.tenantId = defaultTenantId;
        }
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        keywords: undefined
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "添加用户";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.openDataScope = true;
      state.title = "修改用户";
      reset();
      const roleId = row.id;
      getUsersForm(roleId).then(response => {
        state.form = response.data;
      });
    };
    const handleDataScope = function (row) {
      getPublicKey1();
      state.open = true;
      state.form1.password = "";
      state.form1.id = row.id;
    };
    //获取公钥
    const getPublicKey1 = function () {
      getPublicKey().then(response => {
        if (response.code == 0) {
          state.publicKey = response.data;
        }
      });
    };
    const submit = function () {
      const formRef = unref(form1);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading1 = true;
          let params = {
            ...state.form1
          };
          let encrypt = new JSEncrypt();
          encrypt.setPublicKey(state.publicKey); //此处为RSA公钥
          params.password = encrypt.encrypt(params.password);
          updatePass(params).then(response => {
            if (response.code == 0) {
              ElMessage.success("密码重置成功");
              state.open = false;
              getList();
            } else {
              ElMessage.error(response.msg);
            }
            state.saveLoading1 = false;
          }).catch(() => {
            state.saveLoading1 = false;
          });
        }
      });
    };
    /** 修改/新增用户提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          if (params.actOp == 1) {
            params.actAuditor = '';
          }
          if (state.form.id) {
            updateUsers(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addUsers(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delUsers(roleIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-gerenzhongxin",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.open = $event),
        size: "600px",
        title: "重置密码",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: _ctx.saveLoading1
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form1",
          ref: form1,
          form: state.form1,
          formRules: state.rules1,
          formData: state.form1Data,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};